'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
Polymer({
  is: 'moskito-author',
  _template: html`
<style include="iron-flex iron-flex-alignment">
a {
  text-decoration: none;
  color: var(--default-primary-color);
}
.moskito-author-wrapper {
  align-items: center; 
  min-width: 94px;
  max-width: 164px;
}
.author-name {
  text-align: center;
}
moskito-avatar.author-avatar {
  --paper-avatar-width: 94px;
  border: var(--default-secondary-color) solid 2px;
  cursor: pointer;
}
</style>
<div class="vertical layout h-spaced moskito-author-wrapper">
    <template is="dom-if" if="{{serialized}}">
  <a href$="/authors/{{author.id}}" target="_self">
      <moskito-avatar src="{{author.attributes.image.miniature.url}}" label="{{author.attributes.name}}" two-chars class="author-avatar"></moskito-avatar>
    </a>
    <div class="author-name">
      <a href$="/authors/{{author.id}}" target="_self">{{author.attributes.name}}</a>
    </div>
  </template>
    <template is="dom-if" if="{{deserialized}}">
  <a href$="/authors/{{author.id}}" target="_self">
      <moskito-avatar src="{{author.image.miniature.url}}" label="{{author.name}}" two-chars class="author-avatar"></moskito-avatar>
    </a>
    <div class="author-name">
      <a href$="/authors/{{author.id}}" target="_self">{{author.name}}</a>
    </div>
  </template>
</div>
`,
  properties: {
    author: {
      type: Array,
      notify: true
    },
    serialized: {
      type: Boolean,
      computed: 'isSerialized(author)'
    },
    deserialized: {
      type: Boolean,
      computed: 'isDeserialized(author)'
    }
  },
  isTranslation: function (title) {
    if (title.original.language === 'fr') {
      return false
    } else {
      return true
    }
  },
  isSerialized: function (author) {
    return (typeof author.attributes !== 'undefined')
  },
  isDeserialized: function (author) {
    return !this.isSerialized(author)
  }
})
